export default __webpack_public_path__ + "static/media/11 1.5ca2edf0.svg";